import { useHelpMenuCustomizationsQuery } from '../__generated__/apollo-hooks';

// Connectors arrive in connection order; like the gateway merge (ADR-006), the last one to set a field wins.
export const useHelpMenuCustomizations = () => {
  const { data, loading } = useHelpMenuCustomizationsQuery();
  const uiConfigurations =
    data?.connectors?.edges?.map((edge) => edge.node.uiConfiguration) ?? [];

  return {
    moreHelp: uiConfigurations.findLast((ui) => ui?.moreHelp?.length)?.moreHelp,
    cliDownload: uiConfigurations.findLast((ui) => ui?.cliDownloadInstructions)
      ?.cliDownloadInstructions,
    loading
  };
};
